import { useSize } from 'ahooks';

export const useHeaderHeight = (): number => {
  const { height } = useSize(
    document.querySelector('#page_header') as HTMLDivElement,
  );

  return height || 0;
};
